import React, { useState, useEffect } from "react";
import api from "../../Services/api"; 
import "../../../assets/css/dist/conselhos.dist.css";

const ConselhoFiscal = (props) => {

    const [deliberativo, setDeliberativo] = useState([]);

    function processObj(data){
        let newobj = [];
        //@ts-ignore

        let titular = [];
        let suplente = [];
        
        //@ts-ignore
        titular = data.filter(x => x.Tipo === "Titular").sort((a, b) => a.Ordem > b.Ordem ? 1 : -1);
        //@ts-ignore
        suplente = data.filter(x => x.Tipo === "Suplente").sort((a, b) => a.Ordem > b.Ordem ? 1 : -1);

        for (let i = 0; i < titular.length; i++) {
            let payload={
                Title: "",
                Suplente: ""
            }
            let suplente_name = "";
            payload.Title = titular[i].Title;
            suplente_name = suplente.filter(x => x.TitularId === titular[i].ID).reduce((acc, curr) => {
                return curr.Title;
            }, "");
            payload.Suplente = suplente_name;
            newobj.push(payload);
        }
        return newobj;
    }

    useEffect(() => {
        api
            .get("/ObterConselhoFiscal")
            .then((response) => {
                setDeliberativo(processObj(response.data.results));
                ;
            })
            .catch((err) => {
                throw new Error(err);
            });
    }, []);

    return (
        <div className="page-conselhos__table">
            <h3> Conselho Fiscal </h3>
            <div className="_table-flex__content mt-5">
                <div className="_table-flex__header">
                    <span>Titular</span>
                    <span>Suplente</span>
                </div>
                <div className="_table-flex__content">
                    
                        {deliberativo?.map((item, index) => (
                             <><div className="line">
                             <span>{item.Title}</span>
                             <span>{item.Suplente}</span>
                             </div>
                         </>

                        ))}
                </div>
            </div>
        </div>
    );
};
export default ConselhoFiscal;